import { useQuery } from '@apollo/client'
import { GET_MEDIA } from './queries/getMedia'

interface IGetMediaProps {
  courseId: string
  enrollmentId: string
  id: string
  enabled?: boolean
}

export const useGetMedia = ({
  courseId,
  enrollmentId,
  id,
  enabled = true,
}: IGetMediaProps) => {
  const { data, loading, error, refetch } = useQuery(GET_MEDIA, {
    variables: { courseId, enrollmentId, id },
    skip: !enabled,
    fetchPolicy: 'network-only',
    context: {
      fetchOptions: {
        cache: 'no-store',
        headers: {
          'Cache-Control': 'no-cache, no-store, must-revalidate',
          Pragma: 'no-cache',
          Expires: '0',
        },
      },
    },
  })

  return { data, loading, error, refetch }
}
